module.exports = __webpack_public_path__ + "static/build-8281ef46c91a9dda8d593cfb4f436dc7.svg";